import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AlertTriangle, Loader2 } from "lucide-react";
import { superApi } from "@/lib/superApi";

export default function SuperSystemReset() {
  const nav = useNavigate();
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await superApi.post("/super/system/reset", { confirm });
      toast.success("Sistema reiniciado");
      nav("/super/inicio");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error al reiniciar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 max-w-lg">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-red-500">Zona peligrosa</div>
        <h1 className="font-display text-4xl text-white mt-1">Reinicio total</h1>
      </div>

      <div className="glass border border-red-500/30 p-5 rounded-sm space-y-3">
        <div className="flex gap-3 text-red-400">
          <AlertTriangle size={24} className="shrink-0" />
          <p className="text-sm text-white/60">
            Borra todas las sucursales, datos operativos y usuarios admin. Solo permanece el super administrador.
            Deberás ejecutar el bootstrap de nuevo.
          </p>
        </div>
      </div>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs uppercase tracking-widest text-white/60">
            Escribe REINICIAR SISTEMA para confirmar
          </label>
          <input
            className="input-dark mt-1"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading || confirm !== "REINICIAR SISTEMA"}
          className="w-full py-3 bg-red-700 hover:bg-red-600 disabled:opacity-40 text-white font-medium rounded-sm flex items-center justify-center gap-2"
        >
          {loading ? <Loader2 className="animate-spin" size={16} /> : null}
          Reiniciar sistema
        </button>
      </form>
    </div>
  );
}
